import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2InteriorConfiguratorImage from './X46MK2InteriorConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import ImageScrubber from './../ImageScrubber'
import { withTranslation, Trans } from 'react-i18next'
import { interiorView08ImageOptions } from './views/InteriorView08'
import { interiorView09ImageOptions } from './views/InteriorView09'

class X46MK2Heads extends Component {
  render () {
    let image = (
      <ImageScrubber
        images={[
          <X46MK2InteriorConfiguratorImage
            key='view08'
            boat='X46MK2'
            configuration={this.props.configuration}
            options={interiorView08ImageOptions}
          />,
          <X46MK2InteriorConfiguratorImage
            key='view09'
            boat='X46MK2'
            configuration={this.props.configuration}
            options={interiorView09ImageOptions}
          />
        ]}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Heads' />
          </h1>
          <p>
            <Trans defaults='Updated heads with Corian countertops and moulded GRP washbasins.' />
          </p>
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2Heads)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2Heads.js